<header class="staff-header">
  <div class="header-content">
    <!-- Logo section -->
    <div class="logo-section">
      <h1 class="logo">VAT System</h1>
      <span class="role-badge staff">เจ้าหน้าที่</span>
    </div>
    
    <!-- User section -->
    <div class="user-section">
      <div class="user-info" *ngIf="currentUser">
        <div class="user-avatar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </div>
        <div class="user-details">
          <span class="user-name">{{ currentUser.email }}</span>
          <span class="user-role">Staff Member</span>
        </div>
      </div>
      
      <button class="logout-btn" (click)="onLogout()" title="ออกจากระบบ">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16,17 21,12 16,7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
      </button>
    </div>
  </div>
</header> 